module.exports = __webpack_public_path__ + "static/media/desarrollo_-01.b6481150.png";